import { BaseController } from './BaseController';
import { debounce } from 'lodash';
import { get } from '../Utils/helpers';

export default class SearchController extends BaseController {
  id = 'SearchController';

  init() {
    this.root = this.getRoot();

    this.searchUrl = 'search/';

    this.searchInput = this.singleChildNode('search-input-box');
    this.resultsWindow = this.singleChildNode('search-results-container');

    this.searchLang = this.getData(this.searchInput, 'searchLang');

    this.searchInput.addEventListener('keyup', debounce(this.handleInputChange, 250));

    this.request = undefined;
  }

  handleInputChange = (e) => {
    e.preventDefault();

    if (this.searchInput.value.length == 0) {
        this.resultsWindow.innerHTML = '';
    }

    const searchString = 'q=' + this.searchInput.value;
    this.request = get(this.searchUrl + '?' + searchString, this.handleCallback);
  };

  handleCallback = (data) => {
    if (this.request.readyState === XMLHttpRequest.DONE) {
        if (this.request.status === 0 || (this.request.status >= 200 && this.request.status < 400)) {
            var respData = JSON.parse(data.target.response);
            this.resultsWindow.innerHTML = respData['results_str'];

            setTimeout(()=>{
                const listenOnChange = new Event('lazy_load');
                window.dispatchEvent(listenOnChange);
            }, 250);
        }
    }
};
}